var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nftcreate"},[_c('h1',{staticClass:"not-visible",attrs:{"data-focus":""}},[_vm._v(_vm._s(_vm.$t('page.nftCreate.title')))]),_c('nft-create-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }